<div class="grid grid-cols-12 flex-col gap-7 text-tertiary-900">
    <section class="col-start-2 col-span-10 text-2xl">
        <span
            >EWA will confirm the accuracy and completeness of the application
            data and make corrections as necessary to ensure compliance with FCC
            rules. This application will be forwarded to Public Safety
            Coordination Associates (PSCA), an IMSA/FCCA collaboration, for
            final public safety certification.</span
        >
    </section>
    <section class="col-start-2 col-span-10 text-2xl">
        <span
            >EWA will provide a quote for PSCA's frequency coordination and any
            required inter-service concurrence fees. The status of public safety
            applications processed through PSCA is tracked within the EWA Cevo
            dashboard.</span
        >
    </section>
    <section class="col-start-3 col-span-8 w-full">
        <app-submit-to-ewa-form-submission
            (submitForm)="handoverToEwaSubmission()"
            [disableSubmission]="!enableSubmission()"
        >
        </app-submit-to-ewa-form-submission>
    </section>
</div>
